/**
 * 分期录入的**共有取值**（批 `116` · `DR-067` §5：「期数取值与手续费文案照抄，别另造一套」）
 *
 * ## 🔴 为什么值得单独一个文件
 *
 * 期数档位（3/6/9/12/18/24/36）与「总手续费 / 每期手续费」两个词，现在有**两个录入入口**：
 * 分期页（`InstallmentsPage`）与记账页（`NewTransactionPage` 的「这笔分 N 期」）。
 * 各写一份字面量的后果是**静默分叉**：哪天加了 48 期只改一处，用户在两个入口看到的档位就不一样 ——
 * 而两边都"看起来正常"，只有对着截图才发现（铁律 24 的同型场景）。
 *
 * ⚠️ 这里的档位是**产品选择**（银行常见档位），不是内核约束：
 * 内核与契约只认 **2–60 的任意整数**（`InstallmentPeriodsMin/Max` + `CreateInstallmentRequestSchema`）。
 * ⇒ 端侧**不给**用户手填任意期数，是为了避免"填了 47 期却和卡面口径对不上"这类体验问题。
 */

/** 录入界面提供的期数档位（**唯一一份**） */
export const INSTALLMENT_PERIOD_OPTIONS = [3, 6, 9, 12, 18, 24, 36] as const;

/** 手续费录入方式（与契约 `feeMode` 同值域） */
export type InstallmentFeeMode = 'total' | 'per_period';

/** 两种方式的**展示名**（唯一一份；`feeMode` 的值本身来自契约，不在这里另立一套） */
export const INSTALLMENT_FEE_MODE_LABELS: Readonly<Record<InstallmentFeeMode, string>> = {
  total: '总手续费',
  per_period: '每期手续费',
};
